import axios from "axios";
import { accessToken } from "./accessToken";
import { API_ROOT } from './paths/ApiRoot'
import { Capacitor } from "@capacitor/core";

let http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL + API_ROOT,
  headers: {
    "X-Client": Capacitor.isNativePlatform() ? "mobile" : "web",
    "X-Client-Version": process.env.VUE_APP_VERSION,
  },
});

http.interceptors.request.use(
  (config) => {
    const token = accessToken.get();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log("error in http interceptor");
    console.log(error)
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log("error in http interceptor");
    console.log(error)

    // network failures carry no response - nothing to intercept
    if (!error.response) {
      return Promise.reject(error);
    }

    if (
      error.response.status === 426 &&
      error.response.data.errors == "client_version_incompatible"
    ) {
      console.log("intercepting app version out of date");
      location.reload();
      return;
    }

    if (error.response.status === 401 && !error.config._retriedAuth) {
      error.config._retriedAuth = true;
      try {
        // SessionService is imported lazily here to avoid the circular
        // import that would result from SessionService -> webHttp -> (nothing)
        // while http -> SessionService -> accessToken (fine), but pinia store
        // -> http -> SessionService keeps things one-directional at load time.
        const { SessionService } = await import("./SessionService");
        await SessionService.exchange();
        error.config.headers["Authorization"] = `Bearer ${accessToken.get()}`;
        return http(error.config);
      } catch {
        document.location.href = "/logout?security_timeout=true";
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default http;
